module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_250_500.100bca6d.png";